module.exports = __webpack_public_path__ + "static/img/rz(7).dfbaae82.jpg";